// extracted by css-extract-rspack-plugin
export default {"root":"root-GE9v7N","index":"index-bIZnnj text-xs-semibold"};